<template>
  <div
    :class="[ns.b(), ns.is(`${shadow}-shadow`), ns.is('border', border)]"
    data-component-name="Card"
    data-event-container
    data-outline="Card"
    :data-outline-label-selector="`.${ns.e('header')}`"
  >
    <div v-if="$slots.header || header" :class="ns.e('header')">
      <slot name="header">{{ header }}</slot>
    </div>
    <div :class="[ns.e('body'), bodyClass]" :style="bodyStyle">
      <slot />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useNamespace } from '@jdesign-vue/hooks'
import { cardProps } from './card'

defineOptions({
  name: 'JdCard',
})

defineProps(cardProps)

const ns = useNamespace('card')
</script>
